export const GTIN_LENGTHS = [8, 12, 13, 14];

export const isGtin = (input) => {
  const s = String(input ?? "").trim();
  return GTIN_LENGTHS.includes(s.length) && /^\d+$/.test(s);
};
